import { Box, Dialog as MuiDialog, type DialogProps as MuiDialogProps, IconButton } from '@mui/material'
import type { PropsWithChildren } from 'react'
import CloseIcon from '~assets/icons/closeModal.svg'

export type ModalProps = PropsWithChildren<MuiDialogProps>

export const MainModalContainer = (
	{ children, onClose, sx, ...props }: ModalProps
) => {
	return (
		<MuiDialog
			onClose={onClose}
			scroll='paper'
			maxWidth='lg'
			sx={{
				...{
					'& .MuiDialog-paper': {
						right: '-36px',
						flexShrink: 0,
						minHeight: '100%',
						scrollbarWidth: 'none',
						borderRadius: 0,
						backgroundColor: 'rgba(255, 255, 255, 0)',
						boxShadow: 0
					}
				},
				...sx
			}}
			{...props}
		>
			<Box display={'flex'} flexShrink={0} marginY={'40px'}>
				{children}
				<IconButton
					aria-label='close'
					onClick={(event) => onClose?.(event, 'escapeKeyDown')}
					sx={{
						position: 'sticky',
						top: '40px',
						backgroundColor: 'surface.light40',
						width: '56px',
						height: '56px',
						marginLeft: '16px'
					}}
				>
					<CloseIcon height={'20px'} width={'20px'} />
				</IconButton>
			</Box>
		</MuiDialog>
	)
}
